import axios from "axios";

export default axios.create({
  baseURL: "https://tmwsales-a5cfefacbf93.herokuapp.com/api",
});

// export default axios.create({
//   baseURL: 'http://localhost:3200/api',
// });
